export const ORG = "org"
export const USER = "user"
